<section
    class="tw-bg-[#0A0A75] tw-text-white tw-relative tw-h-[375px] sm:tw-h-[375px] tw-min-h-[375px] md:tw-min-h-[341px] xl:tw-min-h-[360px]"
>
    <div
        class="tw-max-w-[1380px] tw-mx-auto tw-py-5 tw-min-h-[375px] tw-px-[15px] tw-flex tw-items-start md:tw-items-center tw-justify-center md:tw-justify-start"
    >
        <div class="tw-max-w-[319px] md:tw-max-w-[281px] lg:tw-max-w-[526px] tw-z-0 md:tw-z-10 tw-flex tw-flex-col tw-items-center md:tw-items-start tw-gap-[18px] tw-pl-0 md:tw-pl-[50px] lg:tw-pl-[53px] tw-pt-0 md:tw-pt-0">
            <span
                class="tw-font-bold tw-text-center md:tw-text-left tw-text-[26px] md:tw-text-[38px] tw-w-[219px] md:tw-w-[281px] lg:tw-w-[526px]"
            >
                {{ 'AWARDS.TITLE' | translate }}
            </span>
            <span
                class="md:tw-text-left tw-text-center tw-text-[14px] tw-w-[249px] md:tw-w-[281px] lg:tw-w-[526px] tw-leading-[22px]"
            >
                {{ 'AWARDS.SUBTITLE' | translate }}
        </span>
        </div>
    </div>
    <img
        src="/assets/images/Awards/trophy.png"
        alt="Parnership"
        class="tw-absolute -tw-right-10 md:tw-right-0 tw-bottom-0 tw-z-30 md:tw-z-30 tw-h-[248px] tw-w-[310px] md:tw-w-[433px] md:tw-h-[341px] xl:tw-h-[371px] xl-tw-w-[472px]"
    />
    <img
        src="/assets/images/Awards/ellipse.png"
        alt="Parnership"
        class="tw-absolute tw-h-[101px] tw-w-[197px] md:tw-w-[247px] md:tw-h-[119px] xl:tw-w-[320px] xl:tw-h-[164px] tw-left-[-50px] tw-bottom-[50px] md:tw-left-[350px] md:tw-bottom-[0px] xl:tw-left-[800px] xl:tw-top-[210px] tw-block tw-z-10 tw-rotate-90 md:tw-rotate-0"
    />
    <img
        src="/assets/images/Awards/circle.png"
        alt="Parnership"
        class="tw-absolute tw-w-[58px] md:tw-w-[] xl:tw-w-[84px] tw-h-auto tw-left-[37px] tw-top-[295px] md:tw-left-[370px] md:tw-top-[220px] xl:tw-left-[830px] xl:tw-top-[170px] tw-block tw-rotate-90 md:tw-rotate-0 tw-z-20"
    />
</section>
